import { LightningElement } from "lwc";
import { topLevelNavigation } from "./mockNav";

export default class App extends LightningElement {
  static renderMode = `light`;
  navigation = topLevelNavigation;
}
